import { action } from 'satcheljs';
export default action('ON_QUICK_OPTION_TOGGLE', function (isToggledOn, option) { return ({
    isToggledOn: isToggledOn,
    option: option,
}); });
//# sourceMappingURL=onQuickOptionToggle.js.map